import React, { Fragment, useState } from 'react';
import 'whatwg-fetch';

import { MdSearch as SearchIcon } from '@react-icons/all-files/md/MdSearch';
import { MdClose as CrossIcon } from '@react-icons/all-files/md/MdClose';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { IconButton } from '@material-ui/core';
import useSearch, { Result } from 'src/hooks/api/useSearch';

const useStyles = createUseStyles({
  inputContainer: {
    width: '100%',
    maxWidth: 350,
    display: 'flex',
    alignItems: 'center',
    background: '#fff',
    borderRadius: 20,
    border: '1px solid #f1f1f1',
    boxShadow: '0 6px 12px -5px rgba(65,76,78,.08)',
    padding: '5px 5px 5px 20px',
  },
  emptyQuery: {},
  resetBttn: {
    cursor: 'pointer',
    marginLeft: '.25rem',
    transition: '250ms',
    '&$emptyQuery': {
      width: 0,
      overflow: 'hidden',
    },
  },
  input: {
    width: '100%',
    background: 'transparent',
    border: 'none',
    borderRadius: 0,
    padding: 0,
    lineHeight: '30px',
  },
});

interface Props {
  renderResults: (results: Record<string, Result[]>, params: { loading: boolean; reset: () => void }) => void;
  className?: any;
  onRedirect?: (path: string, state?: Record<string, any>) => void;
  onReset?: () => void;
  onClick?: () => void;
}

const SearchBar = React.forwardRef<HTMLDivElement, Props>(
  ({ className, onRedirect, renderResults, onClick, onReset }, ref) => {
    const classes = useStyles();
    const [query, setQuery] = useState('');
    const { reset, loading, results } = useSearch(query);

    const handleReset = () => {
      onReset?.();
      setQuery('');
      reset();
    };

    const handleQueryChange = (event) => {
      const target = event.target;
      const value = target.value;

      setQuery(value);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (onRedirect && e.key === 'Enter') {
        onRedirect(`/dashboard/search?query=${query}`);
      }
    };

    return (
      <Fragment>
        <div ref={ref} className={clsx(classes.inputContainer, className)}>
          <input
            value={query}
            onClick={onClick}
            onChange={handleQueryChange}
            className={classes.input}
            type='text'
            onKeyDown={handleKeyDown}
            placeholder='Recherche employé, contact, client, ...'
          />

          <CrossIcon
            size={20}
            className={clsx(classes.resetBttn, { [classes.emptyQuery]: !query || query.length <= 0 })}
            onClick={handleReset}
          />

          <IconButton size='small' component={Link} to={`/dashboard/search?query=${query}`}>
            <SearchIcon />
          </IconButton>
        </div>

        {query !== '' && renderResults(results, { loading, reset: handleReset })}
      </Fragment>
    );
  }
);

export default SearchBar;
